import React from "react";

type SettingsProps = {
  isDarkMode: boolean;
  setIsDarkMode: React.Dispatch<React.SetStateAction<boolean>>;
  defaultView: string;
  setDefaultView: React.Dispatch<React.SetStateAction<string>>;
};

export const Settings: React.FC<SettingsProps> = ({
  isDarkMode,
  setIsDarkMode,
  defaultView,
  setDefaultView,
}) => (
  <div className="flex h-full w-full flex-col items-center space-y-4">
    <div
      className={`mt-2 flex flex-col items-start justify-start rounded-lg border-2 ${
        isDarkMode ? "border-darkgreen bg-darkblue" : "border-brown bg-white"
      } w-[22.5rem] p-3 [box-shadow:inset_0_-2px_#342e2e]`}
    >
      <label className={`flex items-center gap-2 ${isDarkMode ? "text-white" : "text-brown"}`}>
        <input
          type="checkbox"
          checked={isDarkMode}
          onChange={() => setIsDarkMode((prev) => !prev)}
          className="h-4 w-4 accent-green-600"
        />
        Dark Mode
      </label>
    </div>

    <div
      className={`flex flex-col items-start justify-start rounded-lg border-2 ${
        isDarkMode ? "border-darkgreen bg-darkblue" : "border-brown bg-white"
      } w-[22.5rem] p-3 [box-shadow:inset_0_-2px_#342e2e]`}
    >
      <label className={`mb-3 font-semibold ${isDarkMode ? "text-white" : "text-brown"}`}>
        Default Pet View
      </label>

      <label
        className={`flex items-center gap-2 cursor-pointer ${
          isDarkMode ? "text-white" : "text-brown"
        }`}
      >
        <input
          type="radio"
          name="defaultView"
          value="timerViewer"
          checked={defaultView === "timerViewer"}
          onChange={(e) => setDefaultView(e.target.value)}
          className="h-4 w-4"
        />
        Pet Timers
      </label>

      <label
        className={`mt-2 flex items-center gap-2 cursor-pointer ${
          isDarkMode ? "text-white" : "text-brown"
        }`}
      >
        <input
          type="radio"
          name="defaultView"
          value="petPasses"
          checked={defaultView === "petPasses"}
          onChange={(e) => setDefaultView(e.target.value)}
          className="h-4 w-4"
        />
        Pet Licences
      </label>
    </div>
  </div>
);
